import axios from "axios";
import { ENV, validateErrorResponse } from "../config/ENV";
import axiosInterceptors from "./axiosInterceptors";

export function createAccountService(createobj) {
  return axiosInterceptors
  .post(ENV.accountsUrl,createobj)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error;
  });
}

export function getAccountsService(
  search,
  itemsPerPage,
  currentPage,
  sortBy,
  sortOrder
) {
  return axiosInterceptors
  .get(ENV.accountsUrl +
    "?search=" +
    search +
    "&ps=" +
    itemsPerPage +
    "&pn=" +
    currentPage +
    "&sortBy=" +
    sortBy +
    "&sortOrder=" +
    sortOrder)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error;
  });
 }

export function showAccountsService(search) {
  return axiosInterceptors
  .get(ENV.accountsUrl,{
    params: {
      search: search,
      ps: 0,
      pn: 0,
    }
  })
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error;
  });
}

export function getAccountService(accountId) {
  let getAccounturl = ENV.accountsUrl + accountId;
  return axiosInterceptors
  .get(getAccounturl)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error;
  });
}

export function updateAccountsService(updateObj, accountId) {
  let updateAccounturl = ENV.accountsUrl + accountId;
  return axiosInterceptors
  .put(updateAccounturl,updateObj)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error;
  }); 
}

export function deleteAccountsService(accountId) {
  let deleteAccounturl = ENV.accountsUrl + accountId;
  return axiosInterceptors
  .delete(deleteAccounturl)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error;
  });  
}

export function addAddressService(createobj,accountId) {
  let addAddressurl = ENV.accountsUrl + accountId + "/addresses";
  return axiosInterceptors
  .post(addAddressurl,createobj)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error;
  }); 
}

export function getAddressesService(
  accountId,
  search,
  itemsPerPage,
  currentPage,
  sortBy,
  sortOrder,

) {
  // let accountId = window.localStorage.getItem("accountId");
  let getAddressurl = ENV.accountsUrl + accountId + "/addresses";
  return axiosInterceptors
  .get(getAddressurl,{
    params: {
      search: search,
      ps: itemsPerPage,
      pn: currentPage,
      sortBy: sortBy,
      sortOrder: sortOrder,
    }
  })
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error;
  }); 
}

export function getAddressService(accountId, addressId) {
  let getAddressurl =
    ENV.accountsUrl + accountId + "/addresses/" + addressId;
    return axiosInterceptors
    .get(getAddressurl)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });  
}

export function getAddressDetailsService() {
  const addressId = window.localStorage.getItem("addressId");
  let getAddressurl = ENV.accountsUrl + "addresses/" + addressId;
  return axiosInterceptors
  .get(getAddressurl)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error;
  });
}

export function updateAddressService(updateObj, accountId, addressId) {
  let updateAddressurl =
    ENV.accountsUrl + accountId + "/addresses/" + addressId;
    return axiosInterceptors
    .put(updateAddressurl,updateObj)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
  }

export function deleteAddressService(addressId) {
  const accountId = window.localStorage.getItem("accountId");
  let getAddressurl =
    ENV.accountsUrl + accountId + "/addresses/" + addressId;
    return axiosInterceptors
    .delete(getAddressurl)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

export function addAccountBenefits(createobj, accountId) {
  let accountsurl = ENV.accountsUrl + accountId + "/benefits";
  return axiosInterceptors
  .post(accountsurl,createobj)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error;
  }); 
}
export function deletebenefitsService(accountId, id) {
  let getBenfitsUrl = ENV.accountsUrl + accountId + "/benefits/" + id;
  return axiosInterceptors
  .delete(getBenfitsUrl)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error;
  });
}

export function getAccountsBenefits(accountId,search, itemsPerPage, currentPage) {
  let accountsurl = ENV.accountsUrl + accountId + "/benefits";

  return axiosInterceptors
  .get(accountsurl,{
    params: {
      search: search,
      ps: itemsPerPage,
      pn: currentPage,
    }
  })
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error;
  });  
}

export function getAccountBenefits(accountId) {
  let accountsurl = ENV.accountsUrl + accountId + "/benefits";

  return axiosInterceptors
  .get(accountsurl)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error;
  });
  }

export function updateBenfitsToAccountService(
  updatebenfitsobject,
  accountId,
  benefitId
) {
  let updateBenfit_url =
    ENV.accountsUrl + accountId + "/benefits/" + benefitId;
    return axiosInterceptors
    .put(updateBenfit_url,updatebenfitsobject)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });  
}

export function uploadAccountLogo(accountId, fileObj) {
  return axiosInterceptors
  .post(ENV.accountsUrl + accountId + "/logo",fileObj)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error;
  });  
}

export function deleteAccountLogo(accountId) {
  let deleteAccountLogoUrl = ENV.accountsUrl + accountId + "/logo";
  return axiosInterceptors
  .delete(deleteAccountLogoUrl)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error;
  });  
}

export function uploadAccountBackGroundImage(accountId, fileObj) {
  return axiosInterceptors
  .post(ENV.accountsUrl + accountId + "/bgimage",fileObj)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error;
  }); 
}

export function deleteAccountBackgroundImage(accountId) {
  let deleteBackgroundImageUrl = ENV.accountsUrl + accountId + "/bgimage";
  return axiosInterceptors
  .delete(deleteBackgroundImageUrl)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error;
  }); 
}
export function getLocationService(search,itemsPerPage,
  currentPage,
  sortBy,
  sortOrder,accountId,locationId) {

    
    let getLocationurl =
    ENV.accountsUrl + accountId + "/locations/"+locationId +"/contacts";
    return axiosInterceptors
    .get(getLocationurl,{
      params: {
        search: search,
        ps: itemsPerPage,
        pn: currentPage,
        sortBy: sortBy,
        sortOrder: sortOrder,
}})
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });  
}
export function getLocationContactService(accountId,locationId,search,itemsPerPage,
  currentPage,
  sortBy,
  sortOrder) {
    let getLocationurl =
    ENV.accountsUrl + accountId + "/locations/"+locationId +"/contacts";
    return axiosInterceptors
    .get(getLocationurl,{
      params: {
        search: search,
        ps: itemsPerPage,
        pn: currentPage,
        sortBy: sortBy,
        sortOrder: sortOrder,
}})
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });  
}



export function addLocations(creatObject,accounId,locationId) {
 
  // alert(locationId,creatObject);
  let locationsurl = ENV.accountsUrl + accounId + "/locations/"+locationId +"/contact";
  return axiosInterceptors
  .post(locationsurl,creatObject)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error;
  }); 
}

export function updateLocationService(updateObj,contactId) {
  const accountId = window.localStorage.getItem("accountId");
  let locationId = 
  window.localStorage.getItem(
    "locationId"
  );
  let updateLocationurl =
    ENV.accountsUrl + accountId + "/locations/" + locationId+"/contacts/"+contactId;
    return axiosInterceptors
    .put(updateLocationurl,updateObj)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
  }
  export function deleteLocationContactService(contactId) {
    const accountId = window.localStorage.getItem("accountId");
    let locationId = 
    window.localStorage.getItem(
      "locationId"
    );
    let getDelLocationurl =
      ENV.accountsUrl + accountId +  "/locations/" + locationId+"/contacts/"+contactId;
      return axiosInterceptors
      .delete(getDelLocationurl)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  }
  export function addContactService(Createobj,accountId) {
  let addContacturl = ENV.accountsUrl + accountId + "/contact";
  return axiosInterceptors
  .post(addContacturl,Createobj)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error;
  });
}


export function getContactsService(accountId,search,itemsPerPage,currentPage, sortBy,
  sortOrder) {
  let getContactsurl = ENV.accountsUrl + accountId + "/contacts";
  return axiosInterceptors
  .get(getContactsurl,{
  params:{
    search:search,
    ps: itemsPerPage,
    pn:currentPage,
    sortBy: sortBy,
    sortOrder: sortOrder,
  }
  })
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error;
  });
}

export function updateContactService(updateObj,accountId,contactId) {
  let updateContacturl = ENV.accountsUrl + accountId + "/contacts/"+contactId;
    return axiosInterceptors
    .put(updateContacturl,updateObj)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
  }


  export function deleteContactservice(contactId,accountId) {
    let deleteContacturl = ENV.accountsUrl + accountId + "/contacts/"+contactId;
    return axiosInterceptors
    .delete(deleteContacturl)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
  }


  export function getContactNotes(account_contact_id) {
    return axiosInterceptors
      .get(ENV.accountsUrl + "contacts/" + account_contact_id + "/notes")
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  }


  export function addContactNotes(notesObj,account_contact_id) {
    return axiosInterceptors
      .post(ENV.accountsUrl + "contacts/" + account_contact_id + "/notes",notesObj)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  }
 export function deleteContactNotes(account_contact_id, account_contact_note_id) {
    return axiosInterceptors
      .delete(ENV.accountsUrl + "contacts/" + account_contact_id + "/notes/"+account_contact_note_id)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  }


  export function getLocationContactNotes(account_location_id,account_contact_id) {
    return axiosInterceptors
      .get(ENV.accountsUrl + "locations/" + account_location_id + "/contacts/"+account_contact_id+"/notes")
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  }
  export function addLocationNotes(notesObj,account_location_id,account_contact_id) {
    return axiosInterceptors
      .post(ENV.accountsUrl + "locations/" + account_location_id + "/contacts/"+account_contact_id+"/notes",notesObj)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  }
 export function deleteLocationContactNotes(account_location_id,account_contact_id, account_contact_note_id) {
    return axiosInterceptors
      .delete(ENV.accountsUrl + "locations/" + account_location_id + "/contacts/"+account_contact_id+"/notes/"+account_contact_note_id)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  }


  export function allContacts (accountId){
    return axiosInterceptors
    .get(ENV.accountsUrl+accountId+"/allcontacts").then((response)=>{
      return response;
    })
    .catch((error)=>{
      return error;
    })
  }
